import React from "react";
import { Motion, spring } from 'react-motion';

export default class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            open: 1,
            end: 0
        };
    }

    getStyle() {
        return this.style;
    }
    onRest() {
        // eslint-disable-next-line
        this.state.open += 1;
        // eslint-disable-next-line
        this.state.end += 1;
        // console.log("rest called........", this.state.open, this.state.end);
    }


    render() {
        // console.log("page render called");
        return (

            <div className="page">
                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.open) }} onRest={this.onRest.bind(this)} >
                    {({ x }) => {
                        //console.log(x - this.state.end);
                        return (
                            <div style={{
                                opacity: (x - this.state.end)
                            }}>
                                {this.props.children}
                            </div>
                        );
                    }}
                </Motion>


            </div>


        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/pages/page.jsx